import { message } from 'antd';
import actions from './actions';
import { DataService } from '../../config/dataService/dataService';
import { logOut } from '../authentication/actionCreator';
import { getItem } from '../../utility/localStorageControl';

const {
  notificationsReadBegin,
  notificationsReadSuccess,
  notificationsReadErr,

  notificationsDeleteBegin,
  notificationsDeleteSuccess,
  notificationsDeleteErr,
} = actions;

const notificationsDataRead = (id) => {
  return async (dispatch) => {
    try {
      await dispatch(notificationsReadBegin());
      const response = await DataService.get(`/push-notifications/${id}`);
      const token = getItem('access_token');
      if (token && response !== null && response.data.Error === false) {
        await dispatch(notificationsReadSuccess(response.data.payload));
      } else if (token && response !== null && response.data.Error === true && response.data.statusCode !== 401) {
        message.error(response.data.message);
        await dispatch(notificationsReadSuccess(null));
      }
      else {
        if (response.data.Error === true && response.data.statusCode === 401) {
          message.error(response.data.message);
          await dispatch(notificationsReadSuccess(null));
          dispatch(logOut())
        }
      }
    } catch (err) {
      await dispatch(notificationsReadErr(err));
      if (err.message === "Network Error") {
        message.error("Server is down, please contact developer team")
        dispatch(logOut())
      } else {
        message.error(err.message);
      }
    }
  };
};

const notificationsDataDelete = (data) => {
  return async (dispatch) => {
    try {
      await dispatch(notificationsDeleteBegin());
      const response = await DataService.delete(`/push-notifications/delete`, data);
      const token = getItem('access_token');
      if (token && response !== null && response.data.Error === false) {
        await dispatch(notificationsDeleteSuccess(response.data));
        message.success(response.data.message);
      } else if (token && response !== null && response.data.Error === true && response.data.statusCode !== 401) {
        message.error(response.data.message);
        await dispatch(notificationsDeleteSuccess(null));
      }
      else {
        if (response.data.Error === true && response.data.statusCode === 401) {
          message.error(response.data.message);
          await dispatch(notificationsDeleteSuccess(null));
          dispatch(logOut())
        }
      }
    } catch (err) {
      await dispatch(notificationsDeleteErr(err));
      if (err.message === "Network Error") {
        message.error("Server is down, please contact developer team")
        dispatch(logOut())
      } else {
        message.error(err.message);
      }
    }
  };
};

export {
  notificationsDataRead,
  notificationsDataDelete,
};
